export enum CorporateAccountType {
	FULL = 1,
	BETA = 2,
	STARTER = 3,
}
